import { render, staticRenderFns } from "./herder.vue?vue&type=template&id=74ed1c16&scoped=true"
import script from "./herder.vue?vue&type=script&lang=js"
export * from "./herder.vue?vue&type=script&lang=js"
import style0 from "./herder.vue?vue&type=style&index=0&id=74ed1c16&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ed1c16",
  null
  
)

export default component.exports